'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import translations from './translation.js';
import LineClampText from './LineClampText.js';
import { HRInsiderWrapper } from './HRInsider.css.js';

function stripHtmlTags(html) {
    return html.replace(/<[^>]*>/g, '');
}
var ArticleList = function (props) {
    var _a = props.apiUrl, apiUrl = _a === void 0 ? 'https://ms.vietnamworks.com' : _a, _b = props.viewAllUrl, viewAllUrl = _b === void 0 ? 'https://www.vietnamworks.com/hrinsider' : _b, _c = props.vnwUrl, vnwUrl = _c === void 0 ? 'https://www.vietnamworks.com' : _c, tagIds = props.tagIds, _d = props.language, language = _d === void 0 ? 'vi' : _d, _e = props.limit, limit = _e === void 0 ? 4 : _e, _f = props.utm, utm = _f === void 0 ? '' : _f;
    var _g = useState([]), articles = _g[0], setArticles = _g[1];
    var utmData = utm.startsWith('?') ? utm : '?' + utm;
    var t = function (text) {
        if (language === 'vi') {
            return translations[text];
        }
        return text;
    };
    var getArticles = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, data, articles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = tagIds && tagIds.length > 0
                        ? "".concat(apiUrl, "/navi-api/api/blogs-by-hr-tag?tag_ids=").concat(tagIds.join(','), "&limit=").concat(limit)
                        : "".concat(apiUrl, "/navi-api/api/blogs?limit=").concat(limit);
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (Array.isArray(data) && data.length > limit) {
                        data = data.slice(0, limit);
                    }
                    articles = data.map(function (item) {
                        var image = item.cover_picture;
                        var tags = item.tags || [];
                        var category = tags.map(function (item) { return item.name; }).join(', ');
                        return {
                            id: item.id,
                            title: stripHtmlTags(item.title),
                            image: image,
                            description: stripHtmlTags(item.short_description),
                            url: vnwUrl + item.hrDetailSlug + utmData,
                            category: category
                        };
                    });
                    setArticles(articles);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getArticles();
    }, []);
    useEffect(function () {
        getArticles();
    }, [tagIds]);
    return (React__default.createElement(HRInsiderWrapper, null,
        React__default.createElement("div", { className: 'flex-space-between article-title' },
            React__default.createElement("h2", null, t('Career Advice From HR Insider')),
            React__default.createElement("a", { href: viewAllUrl + utmData, target: 'blank' }, t('View all'))),
        React__default.createElement("div", { className: 'article-list' }, articles.map(function (article) { return (React__default.createElement("div", { key: article.id, className: 'article-item' },
            React__default.createElement("div", { className: 'image-wrapper' },
                React__default.createElement("div", { className: 'el-wrapper169' },
                    React__default.createElement("div", { className: 'el-inner' },
                        React__default.createElement("img", { src: article.image, alt: article.title, className: ' el-img-fit' })))),
            React__default.createElement("div", { className: 'article-content' },
                React__default.createElement("a", { href: article.url, className: 'article-link' },
                    React__default.createElement(LineClampText, { content: article.title, lines: 3 })),
                React__default.createElement(LineClampText, { content: article.description, lines: 4 }),
                article.category !== '' && (React__default.createElement("div", { className: 'cardBlock__category ellipsis' },
                    React__default.createElement("span", { className: 'cardBlock__point' }),
                    React__default.createElement("span", null, article.category)))))); }))));
};

export { ArticleList as default };
//# sourceMappingURL=index.js.map
